export default __webpack_public_path__ + "static/media/cadbury.0c4df1b9.png";